import { writable } from 'svelte/store';
export const AUCTION_STORE = writable({});
export const AUCTION_HASH = writable('initial');
